// Components
import { KiteIcon, KiteMenu, KiteMenuItem } from '@kite/react-kite';
import { useKeycloak } from '@studio-toolkit/keycloak';

// Styles
import './Nav.scss';
import { Link } from 'react-router-dom';

interface INavProps {
  /** Optional custom css class */
  className?: string;
}

/** Used to navigate between pages */
const Nav = ({ className = '' }: INavProps) => {
  const { keycloakUser } = useKeycloak();
  const userDisplayName =
    keycloakUser?.family_name && keycloakUser?.given_name
      ? `${keycloakUser.family_name}, ${keycloakUser.given_name}`
      : '';

  const renderMenuItems = () => (
    <>
      <KiteMenuItem
        variant="link"
        href="https://www.irs.gov/pub/irs-pdf/fw9.pdf"
        target="_blank"
        // icon="ki-linkout"
      >
        Download W9 Form
      </KiteMenuItem>
      <KiteMenuItem>
        <Link className="page-link" to="/profile">
          <span className="link-text">Profile</span>
        </Link>
      </KiteMenuItem>
      <KiteMenuItem
        variant="link"
        // href="/"
        // target="_blank"
        onClick={() => {
          console.log('logout');
        }}
        // icon="ki-linkout"
      >
        Sign Out
      </KiteMenuItem>
    </>
  );

  const renderTextMenu = () => (
    <div className="kite-position__relative user-menu-container">
      <span className="nav-username">
        {userDisplayName}
        <KiteIcon icon="ki-chevron-down" color="#ffffff" size="14px" />
      </span>
    </div>
  );

  const renderIconMenu = () => (
    <div className="kite-position__relative user-menu-container__icon">
      <KiteMenu
        ariaLabel="User Action Menu"
        menuIcon="ki-person"
        className="nav-user-menu"
      >
        {renderMenuItems()}
      </KiteMenu>
    </div>
  );

  return (
    <nav className={`nav ${className}`}>
      <div className="nav__left">
        <a data-testid="spectrumLogo-homeLink" href="/">
          <img src="/spectrum-logo--color.svg" />
        </a>
        <Link
          className="nav-near-logo-link"
          to="/"
          // style={{ marginLeft: '12px' }}
        >
          Print On-Demand
        </Link>
      </div>
      <ul className="header-list">
        <li>
          <button
            className="bell-icon-btn"
            type="button"
            aria-label="Notifications"
          ></button>
        </li>
        <li>
          {renderTextMenu()}
          {renderIconMenu()}
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
